import { useEffect, useState } from 'react';
import { HydraQueryParams } from '../../../libs/api-client/hooks/useHydraQuery';
import { OmvqVeterinarian, useSearchOmvqVeterinariansQuery } from '../../../libs/api-client';

function toItem(omvqVeterinarian: OmvqVeterinarian) {
  const clinicsName = omvqVeterinarian?.omvqEstablishmentVeterinarians?.map(
    omvqEstablishmentVeterinarian => {
      return omvqEstablishmentVeterinarian.omvqEstablishment.name;
    }
  );

  return {
    '@id': omvqVeterinarian?.['@id'],
    id: omvqVeterinarian?.id,
    name: omvqVeterinarian?.name,
    clinics: clinicsName,
    permitNumber: omvqVeterinarian?.permitNumber,
    omvqStatus: omvqVeterinarian?.omvqStatus,
    status: omvqVeterinarian?.status,
  };
}

export function useSearchOmvqVeterinarians<D extends { name: string }>(
  params?: HydraQueryParams<D>
) {
  const [searchResult, setSearchResult] = useState({ items: [] });
  const [searchQuery, setSearchQuery] = useState<string>();

  const {
    refetch: refetchGetOmvqVeterinarians,
    isLoading,
    isFetching,
  } = useSearchOmvqVeterinariansQuery<any>({
    ...params,
    vars: {
      searchQuery,
    },
    options: {
      onSuccess(result) {
        const normalizedResults = result?.member?.map((omvqVeterinarian: OmvqVeterinarian) => {
          return toItem(omvqVeterinarian);
        });

        setSearchResult({
          items: normalizedResults,
        });
      },
      enabled: false,
    },
  });

  const clearSearchResult = () => setSearchResult({ items: [] });

  useEffect(() => {
    if (searchQuery && searchQuery?.length >= 3) {
      refetchGetOmvqVeterinarians();
    }
  }, [searchQuery, refetchGetOmvqVeterinarians]);

  const search = (searchQuery: string) => {
    setSearchQuery(searchQuery);
  };

  return {
    searchResult: {
      items: [...searchResult.items].sort((a: { name: string }, b: { name: string }) =>
        a.name.localeCompare(b.name)
      ),
    },
    search,
    clearSearchResult,
    isLoading,
    isFetching,
  };
}
